import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';
import { surveyResponsesStateForSurveyIdSelector } from '../../../reducers/survey-selectors';

import * as Api from '../../../api/api';

export const loadSurveyResponses = (surveyId: number) =>
  createGenericDispatcher<Array<SurveyResponse>>({
    name: 'LOAD_SURVEY_RESPONSES',
    loadFunction: () => Api.get(`/survey-responses?surveyId=${surveyId}`),
    args: { surveyId },
    shouldExecuteSelector: (state: any) => surveyResponsesStateForSurveyIdSelector(state, surveyId),
  });
